module.exports = __webpack_public_path__ + "img/ozon.b1c4c092.png";